import { OrganizationManager, Team } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { TeamManagerEntityConfig } from "./config";
import { TeamManagerFilters } from "./filters";
import { TeamManagerMethods } from "./methods";

@HyperEntity("team-manager", TeamManagerEntityConfig)
export class TeamManager extends extender(
  TeamManagerFilters,
  TeamManagerMethods,
) {
  @Fields.string({ dbName: "manager_id" })
  managerId = "";

  @Fields.string({ dbName: "team_id" })
  teamId = "";

  @Relations.toOne<TeamManager, Team>(() => Team, "teamId")
  team?: Team;

  @Relations.toOne<TeamManager, OrganizationManager>(
    () => OrganizationManager,
    "managerId",
  )
  manager?: OrganizationManager;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
